const locationGroupsActionTypes = {
  SET_LOCATION_GROUPS: 'SET_LOCATION_GROUPS',
  ADD_LOCATION_GROUP: 'ADD_LOCATION_GROUP',
  UPDATE_LOCATION_GROUP: 'UPDATE_LOCATION_GROUP',
  DELETE_LOCATION_GROUP: 'DELETE_LOCATION_GROUP',
  SET_LOCATION_GROUPS_FETCHED_INFO: 'SET_LOCATION_GROUPS_FETCHED_INFO',
};
export default locationGroupsActionTypes;
